import React from 'react'
import PropTypes from 'prop-types'
import GroupMoreButton from "./group-more-button/group-more-button"
import FieldGlistGroup from "../../../../fields3/render/glist/glist-group";

export default class GlistGroupHeaderCell extends React.Component {

    static propTypes = {
        module  : PropTypes.object,
        column  : PropTypes.object,
        group   : PropTypes.object,

        onClick : PropTypes.func,
    }

    render() {
        const field = this.props.module.fields.get(this.props.module.groupBy.value)
        const isSticky  = this.props.module.titleSticky

        const classes = Classes("cell group-header-cell", this.props.className, {
            sticky: isSticky
        })

        const styles = {
            width:this.props.column.width
        }
        if (isSticky) {
            styles.left = this.props.module.skin.paddingLeft
        }

        return (
            <div className={classes} style={styles} onClick={this.props.onClick}>
                {/*{field.gList.renderGroup({value: this.props.group.groupByValue}, this.props.module, false)}*/}
                <FieldGlistGroup field={field} glist={this.props.module} data={{value: this.props.group.groupByValue}} isCollapsed={false} />
                <GroupMoreButton isCollapsed        = {false}
                                 onToggleCollapse   = {this.props.onClick}/>
                {isSticky && <div className="sticky-shadow-emitter"/>}
            </div>
        )
    }
}
